import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { Locale } from '@fastnorth/i18next';
import { Div } from '@fastnorth/kraken/components/layout';
import type { SubEventProgressOverview } from '../types';
import RaceSectionHeader from './RaceSectionHeader';
import SplitTableHeader from './SplitTableHeader';
import SplitTableRow from './SplitTableRow';
import StatusTotals from './StatusTotals';
import { splitTableVariants } from './SplitTable.styles';

export type SubEventProgressSectionProps = {
  subEvent: SubEventProgressOverview;
  timeZone: string;
};

const SubEventProgressSection = ({
  subEvent,
  timeZone,
}: SubEventProgressSectionProps): ReactElement => {
  const { i18n } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });
  const locale = i18n.language as Locale;

  return (
    <Div
      className="w-full min-w-0"
      data-testid={`sub-event-progress-${subEvent.subEventId}`}
      spacing="0 0 0">
      <RaceSectionHeader
        raceName={subEvent.name}
        resultsLastModifiedAt={subEvent.resultsLastModifiedAt}
        subEventId={subEvent.subEventId}
        timeZone={timeZone}
      />
      <Div
        className={splitTableVariants()}
        data-testid={`sub-event-progress-table-${subEvent.subEventId}`}>
        <StatusTotals
          dnfCount={subEvent.dnfCount}
          dnsCount={subEvent.dnsCount}
          dqCount={subEvent.dqCount}
        />
        <SplitTableHeader />
        {subEvent.checkpoints.map((row, index) => (
          <SplitTableRow
            key={`${row.kind}-${row.label}-${index}`}
            locale={locale}
            row={row}
            timeZone={timeZone}
          />
        ))}
      </Div>
    </Div>
  );
};

export default SubEventProgressSection;
